/* eslint-disable react/require-default-props */
import { BaseButton } from 'components/elements/BaseButton'
import React, { FC } from 'react'
import { utils } from 'utils'
import { TCreditPaymentDetails, TCreditPlans } from '../types'
import { useCreatePaymentIntentMutation } from '../api'

const PurchaseCreditPlanItem: FC<{
 onBeforePayment?: (v?: TCreditPaymentDetails) => void
 item: TCreditPlans
}> = ({ item, onBeforePayment }) => {
 const [createPaymentIntent, { isLoading }] = useCreatePaymentIntentMutation()
 const handleBuy = async (item: any) => {
  try {
   const paymentData = await createPaymentIntent({
    plan_id: item.id,
   }).unwrap()
   onBeforePayment?.(paymentData)
  } catch (error) {
   console.error('Failed to create payment intent', error)
  }
 }

 return (
  <li>
   <div className="itm-bbb-price">
    <h4>{utils.pricefy(item.price)}</h4>
    <span>{item.currency}</span>
   </div>
   <div className="itm-bbb">
    <span>Vaidity</span>
    <span>
     <strong>{item.expire_in_days} Days</strong>
    </span>
   </div>
   <div className="itm-bbb">
    <span>Quantity</span>
    <span>
     <strong>
      {item.quantity} {item.type === 'sms' ? 'SMS' : 'Emails'}
     </strong>
    </span>
   </div>
   <div>
    <BaseButton
     shape="round"
     loading={isLoading}
     buttonType="primary"
     size="small"
     onClick={() => handleBuy(item)}
    >
     Buy Now
    </BaseButton>
   </div>
  </li>
 )
}

export default PurchaseCreditPlanItem
